export * from "./result.js";
export * from "./session.js";
export * from "./registry.js";
export * from "./i18n.js";
export * from "./unit-catalogue.js";
export * from "./manifest.js";
export * from "./derive.js";
export { foldArabic } from "./arabic.js";
export * from "./render.js";
export * from "./row-focus.js";
export * from "./list.js";
export * from "./saved-views.js";
export * from "./saved-views-menu.js";
export * from "./board.js";
export { Timeline, timelineFits } from "./timeline.js";
export { timelineOf, scalesOf, inspectTimeline, TIMELINE_SCALES } from "./timeline-model.js";
export * from "./list-views.js";
export * from "./calendar-model.js";
export * from "./calendar.js";
export * from "./export.js";
export * from "./bulk.js";
export { workbook, templateWorkbook } from "./export-xlsx.js";
export * from "./import.js";
export { printDocument, openPrintView } from "./export-print.js";
export { wordDocument, documentParts, DOCX_TYPE } from "./export-docx.js";
export * from "./paper.js";
export * from "./lines.js";
export * from "./ui.js";
export * from "./hotkeys.js";
export * from "./fields.js";
export * from "./media-store.js";
export * from "./blocks.js";
export * from "./toast.js";
export * from "./conversation.js";
export * from "./chart.js";
export * from "./form.js";
export * from "./form-preview.js";
export * from "./record.js";
export * from "./hub.js";
export * from "./report.js";
export * from "./settings.js";
export * from "./views.js";
export * from "./meter-panel.js";
export { ChartPanel, trendSeries } from "./chart-panel.js";
export * from "./home-model.js";
export * from "./home.js";
export * from "./home-markup.js";
export * from "./home-script.js";
import { ui } from "./ui.js";
import { AudioInput, DateInput, FileInput, NumberInput, TimeInput, setDateDisplay } from "./fields.js";
import { blocks } from "./blocks.js";
import { toasts } from "./toast.js";
import { conversation } from "./conversation.js";
import { views } from "./views.js";
import { charts } from "./chart.js";
import { Form, FormDialog, FormPage, useFormValues } from "./form.js";
import { FormPreview, useFormPreview } from "./form-preview.js";
export const SDK_VERSION = '0.1.0';
export function createSdk(o) {
    const features = o.features;
    return {
        ...(o.create ? { create: o.create } : {}),
        ...(features ? { feature: (module, key) => features(module)?.has(key) ?? false } : {}),
        ...(o.recordLink ? { recordLink: o.recordLink } : {}),
        ...(o.findRecords ? { findRecords: o.findRecords } : {}),
        ...(o.recordName ? { recordName: o.recordName } : {}),
        ...(o.storeFile ? { storeFile: o.storeFile } : {}),
        version: SDK_VERSION,
        unit: o.unit,
        components: o.components,
        session: o.session,
        i18n: o.i18n,
        api: {
            get: (path) => o.session.get(o.unit.baseUrl, path),
            send: (path, init) => o.session.send(o.unit.baseUrl, path, init),
            post: (path, body) => o.session.send(o.unit.baseUrl, path, { method: 'POST', body }),
        },
        t: (key, vars) => o.i18n.t(key, vars),
        dates: { show: (display) => setDateDisplay(display) },
        ui: { ...ui, ...blocks, ...charts, ...views, ...conversation, ...toasts, NumberInput, DateInput, TimeInput, FileInput, AudioInput, Form, FormDialog, FormPage, useFormValues, FormPreview, useFormPreview },
    };
}
export * from "./assist.js";
export { TIERS, isTier, tierReaches, withoutHiddenFeatures } from '@erp-sslab/schema/tiers';
//# sourceMappingURL=index.js.map